import { createApiOpt } from './utils';

const localName = 'phome';
const serverName = `mizhua.${localName}.PHomeExtObj`

/**
 * banner
 * @param data
    ExtraModType mod_type = 1;
      EMT_NONE = 0;
      EMT_SEARCH_PLAYER_BANNER = 1;//PHomeEntryBannerList
      EMT_SEARCH_ROOM_BANNER = 2;//PHomeEntryBannerList
      EMT_RECENT_ROOM = 3;//PHomeEntryRoomList
      EMT_RADIO_STATION = 4; // RadioStationList
      EMT_IM_NEARBY = 5; // PHomeEntryPlayer
      EMT_Bill_Evaluate_BANNER = 6;// 点单评价banner PHomeEntryBannerList
      EMT_ACTIVITY_DIALOG_BANNER = 7; //活动弹窗banner PHomeEntryBannerList
    PHomeClassify fiter_classify = 2;   //订单的性别过滤条件
      HMC_ClassifyNone = 0; // 占位
      HMC_ClassifySexAll = 1; // 所有性别
      HMC_ClassifyAllMale = 2; // 性别男
      HMC_ClassifyAllFemale = 3; // 性别女
    int32 index = 3; // 首页传0
 */
export function apiExtraMod(data) {
  return createApiOpt(localName, 'ExtraMod', data, {
    serverName
  });
}

/**
 * 获取分享热点
 * @param
 int64 share_id = 1; // 分享ID
 * @returns
 CommunityTrendsDetailRes detail_res = 1;// 详情
 CommunityTrendsCommentsRes comment_res = 2;//评论

 message CommunityTrendsCommentsRes {
    TrendsComment comments = 1;
    int32 comment_num = 2;  // 评论数量
 }

 message CommunityTrendsDetailRes {
    CommunityTrendData  trends      = 1;
    repeated CommunityPlayerInfo likers   = 2;  //点赞id列表预览
    HotPointDetail hot = 3 ; //热点信息
 }

 message CommunityTrendData {
    int64             id                = 1;  // 动态ID
    Publisher         publisher         = 2;  // 发布者ID
    string            content           = 3;  // 动态内容
    int32             like_num          = 4;  // 点赞数量
    int32             comment_num       = 5;  // 评论数量
    repeated TrendTag tags              = 6;  // 标签
    int64             publish_at        = 7;  // 发不时间
    repeated MediaResource media_urls   = 8;  //多媒体资源列表
    bool              is_gave_like      = 9;  // 是否点过赞
    int32             index             = 10;
    repeated GroupInfoSimple groups     = 11;
    repeated AtPlayer at_player         = 12; // @用户
    int64             top               = 13;  // 设置置顶的时间戳
    int32 skill_id = 14; // 技能id
    int32 ia_id = 15; // 互动id
    int32 activity_id = 16; // 该条视频的活动id，没有则0
    repeated PAuthInfo auth_info_list = 17; // 用户认证信息
    string tag_url = 18; // 标签url
    int32 play_num = 19; // 播放次数
    TrendsType trends_type = 20;   //动态类型
 }

 message CommunityPlayerInfo {
    int64 id            = 1;
    int64 id2           = 2;
    string nick_name    = 3;
    string icon         = 4;
    PluginSexType sex   = 5;
 }

 enum PublishGroupType {
    PublicGroupType_None        = 0; //占位不用
    PublicGroupType_Public      = 1; //公开
    PublicGroupType_Select      = 2; //指定圈子
 }

 message HotPointDetail {
    int64 hot_point_id = 1; // 热点ID
    int64 player_id = 2; // 用户ID
    string name = 3; // 用户昵称
    string icon = 4; // 用户头像
    int32 gold = 5; // 金币
    int32 heat = 6; // 热度值
    string content = 7; // 热点内容
    string content_response = 8; // 热点回应内容
    int64 content_response_time = 9; // 热点回应时间(时间戳:秒)
    ContentResStatus content_response_status = 10; // 热点回应内容状态
    repeated MediaResource content_response_media_urls   = 11;  //热点回应多媒体资源列表
    bool is_valid = 12; //是否7天有效
    repeated FirepowerRank heatRank = 13; //火力值榜前3
    repeated AtPlayer res_at_player = 14; // 热点回应 @用户
    int32  un_shelve_gold=15;//最新下架金币数量
    PluginHotPointType type = 16; // 热点类型
    HotPointStatus status = 17; // 热点状态
    int32 ResponseLimit = 18; // 回应字数限制
    bool is_on_rank = 19; //是否在榜
    float RemoveHotPointCoefficient = 20; //撤榜系数
 }

 message TrendsComment {
    int64 trends_id             = 1;
    int64 trends_player_id      = 2;                // 动态主人id， 我是动态主人可以删除动态
    int32 comment_id            = 3;
    int32 level                 = 4;                //评论层级
    int32 comment_num           = 5;                //评论数量
    repeated TrendsCommentDetail details = 6;       //评论
    int32 next_index                = 7;            //-1代表列表没有下一页了, 否则可以用此值在CommunityTrendsCommentsReq中请求下一页
 }
 */
export function apiGetShareHotDetail(data) {
  return createApiOpt(localName, 'GetShareHotDetail', data, {
    reqDesction: 'HotShareReq',
    resDesction: 'HotShareRes',
    serverName,
  });
}

/**
 * 获取文章的热门评论
 * @params
 int64 user_id = 1;             // '用户id'
 int64 article_id = 2;          // '文章id',
 * @returns
 repeated CommentInfo comment_list= 1;    //评论列表

 message CommentInfo {
   int64 id = 1;                            // '序号'
   int64 article_id = 2;                    // '文章id',
   string article_name  =3;                 // '文章标题',
   string content   =4;                     // '评论内容',
   int64  like_count  =5;                   // '点赞数',
   int64 comment_count =6;                  // '评论数',
   int64 parent_id =7;                      // '父评论id'，没有则为0,
   int64 user_id   =8;                      // '用户id',
   string user_name =9;                     // '玩家名称',
   string user_icon =10;                    // '玩家头像',
   sint32 charm_level = 12;                 // '魅力等级
   sint32 wealthl_evel = 13;                // '财富等级
   int64 to_user_id   =14;                  // '回复给用户id',
   string to_user_name =15;                 // '回复给玩家名称',
   bool has_like = 16;                      // '是否有点赞过该条评论'
   int64 create_at = 17;                    // '创建时间'
   repeated CommentInfo child_comment = 18; // '子评论'，没有则为空
   bool isTop = 19;                         // '是否置顶'
   int32 like_num = 20;                     // '点赞数量'
 }
 */
export function apiGetHotCommentListByArticleId(data) {
   return createApiOpt(localName, 'GetHotCommentListByArticleId', data, {
      serverName
   });
}

/**
 * 获取文章的评论列表
 * @params
   int64 user_id = 1;             // '用户id'
   int64 article_id = 2;          // '文章id',
   int64 parent_id =3;            // '父评论id，没有则为0',
   int64 lastId =4;               // '上一条展示的评论id，没有则为0',
   int64 page_size = 5;           // '一次获取的评论条数'
 * @returns
   repeated CommentInfo comment_list= 1;    //评论列表
   bool has_more = 2;                       //是否还有更多评论
   int64 like_count = 3;                    //文章的点赞数    lastId 为0时返回
   int64 comment_count = 4;                 //文章的评论数数  lastId 为0时返回
   bool like = 5;                           //true 点赞， false 取消点赞   lastId 为0时返回
 */
export function apiGetCommentListByArticleId(data) {
   return createApiOpt(localName, 'GetCommentListByArticleId', data, {
      serverName
   });
}

/**
 * 添加文章的评论
 * @params
   int64 article_id = 1;          // '文章id',
   string article_name  =2;       // '文章标题',
   int64 parent_id =3;            // '父评论id'，没有则为0,
   string content   =4;           // '评论内容',
   int64 to_user_id   =5;         // '回复给用户id',
   string to_user_name =6;        // '回复给玩家名称',
   string comment_url =7;         // '回复的url链接， 系统消息时使用',
 * @returns
   int64 id = 1;                  // '评论id'
 */
export function apiAddArticleComment(data) {
   return createApiOpt(localName, 'AddArticleComment', data, {
      serverName
   });
}

/**
 * 删除文章的评论
 * @params
   int64 id = 1;                  // '评论id'
   int64 article_id = 2;          // '文章id',
   int64 parent_id =4;            // '父评论id'，没有则为0,
 * @returns
   空
 */
export function apiDelArticleComment(data) {
   return createApiOpt(localName, 'DelArticleComment', data, {
      serverName
   });
}

/**
 * 点赞或者取消点赞
 * @params
   int64 article_id  = 1;         //文章id
   int64 comment_id  = 2;         //评论id
   int64 parent_comment_id = 3;   //父评论id，没有则为0
   bool like = 4;                 //true 点赞， false 取消点赞
 * @returns
   空
 */
export function apiUpdateCommentLike(data) {
   return createApiOpt(localName, 'UpdateCommentLike', data, {
      serverName
   });
}

/**
 * 判断用户是否有管理员权限
 * @params
   空
 * @returns
   bool is_admin = 1;            // true 有管理员权限，false, 没有权限
 */
export function apiCheckUserIsAdmin(data) {
   return createApiOpt(localName, 'CheckUserIsAdmin', data, {
      serverName
   });
}

/**
 * 获取文章当前的评论信息
 * @params
   int64 user_id = 1;             // '用户id'
   int64 article_id = 2;          // '文章id',
   int64 comment_id = 3;          // '评论id',
 * @returns
   CommentInfo comment_info = 1;  //评论信息
   repeated CommentInfo hot_comment_list= 2;    //置顶或热门评论列表
 */
export function apiGetCommentInfoByArticleId(data) {
   return createApiOpt(localName, 'GetCommentInfoByArticleId', data, {
      serverName
   });
}
